import React, { useState, useEffect } from "react";
import { Alert, Button, FormGroup, Input, Row, Col } from "reactstrap";
import { GetAuth, PostAuth, PutAuth } from "../utils/Verbs";
import { useVsiAppContext } from "../stores/VsiApp";

export default function NoteEditor({ clientId, noteKey }) {
  const { client, getAccessTokenSilently } = useVsiAppContext();
  const [isDirty, setIsDirty] = useState(false);
  const [isNoteSaveSuccessMessageDisplayed, setIsNoteSaveSuccessMessageDisplayed] = useState(false);
  const [isNoteSaveFailureMessageDisplayed, setIsNoteSaveFailureMessageDisplayed] = useState(false);
  const [noteText, setNoteText] = useState("No notes for this device.");
  const [isNoteExisting, setIsNoteExisting] = useState(false);
  const onHandleTextAreaChange = event => {
    setNoteText(event.target.value);
    setIsDirty(true);
    setIsNoteSaveSuccessMessageDisplayed(false);
    setIsNoteSaveFailureMessageDisplayed(false);
  };

  const onHandleButtonClick = async event => {
    const encodedNoteKey = encodeURIComponent(noteKey);
    const payload = { clientId: clientId, noteKey: encodedNoteKey, noteText: noteText };
    const token = await getAccessTokenSilently();

    if (isNoteExisting) {
      // update the note
      PutAuth(`/api/v6/admin/notes`, payload, token)
        .then(() => {
          setIsNoteSaveFailureMessageDisplayed(false);
          setIsNoteSaveSuccessMessageDisplayed(true);
          setIsDirty(false);
          setIsNoteExisting(true);
        })
        .catch(error => {
          setIsNoteSaveFailureMessageDisplayed(true);
          setIsNoteSaveSuccessMessageDisplayed(false);
          setIsDirty(true);
        });


    } else {
      // create the note
      PostAuth(`/api/v6/admin/notes`, payload, token)
        .then(() => {
          setIsNoteSaveFailureMessageDisplayed(false);
          setIsNoteSaveSuccessMessageDisplayed(true);
          setIsDirty(false);
          setIsNoteExisting(true);
        })
        .catch(error => {
          setIsNoteSaveFailureMessageDisplayed(true);
          setIsNoteSaveSuccessMessageDisplayed(false);
          setIsDirty(true);
        });
    }
    setIsDirty(false);
    setIsNoteSaveSuccessMessageDisplayed(true);

  };

  useEffect(() => {
    const getNotes = async () => {
      const encodedNoteKey = encodeURIComponent(noteKey);
      const token = await getAccessTokenSilently();
      GetAuth(`/api/v6/admin/notes/${clientId}/${encodedNoteKey}`, token)
        .then(data => {
          setIsNoteExisting(true);
          setIsDirty(false);
          setNoteText(data.data.noteText);
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            setNoteText("");
            setIsNoteExisting(false);
            setIsDirty(false);
          } else {
            console.error("There was a problem loading the note", error);
          }
        });
    };

    getNotes();
  }, [client, noteKey]);

  return (
    <div>
      <Row style={{ marginTop: 15 }}>
        <Col xs={12}>
          <FormGroup>

            <Input type="textarea"
                   value={noteText}
                   style={{ height: 270, maxHeight: 300 }}
                   name="note"
                   id="note"
                   maxLength={2000}
                   onChange={onHandleTextAreaChange}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Alert
            style={{ height: 46, paddingTop: 10 }}
            isOpen={isNoteSaveSuccessMessageDisplayed}
            color={"success"}><i style={{ marginRight: 8 }} className="fa-regular fa-thumbs-up"></i>Your note was saved.</Alert>
          <Alert
            isOpen={isNoteSaveFailureMessageDisplayed}
            color={"danger"}>There was a problem saving your note.</Alert>
        </Col>
        <Col xs={12} lg={4} className="d-flex justify-content-end">
          <Button
            style={{ height: 48, paddingTop: 8, marginRight: 6 }}
            disabled={!isDirty}
            onClick={onHandleButtonClick}>
            Save Note</Button>
        </Col>

      </Row>
    </div>
  );
}
